// Deployment tier, named like the backend's internal.Environment so frontend
// and backend Sentry events share the same environment values.
export function getEnvironment(): "local" | "test" | "production" {
  const { hostname } = window.location;
  if (hostname.includes("localhost")) return "local";
  if (hostname.includes("-test")) return "test";
  return "production";
}
